export default __webpack_public_path__ + "static/media/tiktokDeskFill.984f6cb2.svg";